import { lazy } from "react"
import type { FC, LazyExoticComponent, ReactElement } from "react"

import { ECoachCalendarQueryKey as EQueryKey } from "./coach.calendar.api.config"
import Skeleton from "./coach.calendar.component.skeleton"

const Container: LazyExoticComponent<FC> = lazy(
    (): Promise<{ default: FC }> => import("./coach.calendar.container.link-accounts")
)

const Page: FC = (): ReactElement => (
    <Skeleton container={Container} queryKeys={[EQueryKey.ZoomAccount(), EQueryKey.MsTeamsAccount()]} withBackButton />
)

Page.displayName = "CoachLinkAccountsPage"

export { Page as CoachLinkAccountsPage }
